import FormSelectBox from '../../../../../components/Inputs/FormSelectBox';
import { useGetPreClaimsTypeList } from '../../hooks';

export const PreClaimsTypeSelect = ({
  placeholder = 'Select Type',
  label = 'Type',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  dataTestId,
  className = '',
  tabIndex,
  disableValidation = false,
}) => {
  const { data: options, isLoading } = useGetPreClaimsTypeList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      className={className}
      tabIndex={tabIndex}
      dataTestId={dataTestId}
      disableValidation={disableValidation}
    />
  );
};
